import { computed, ComputedRef, watch, ref } from 'vue';
import { storeToRefs } from 'pinia';
import useMyMemberCollectionsStore from './my-member-collections';
import useHasCollectionContents from './use-has-collection-contents';
import { ContentFilters, MemberRole } from './types';

// simple wrapper around the store to trigger initial loading from a single place
const useMyMemberCollections = (context: string, limit: number, filters?: ComputedRef<ContentFilters>) => {
  const store = useMyMemberCollectionsStore();
  const { collections: storeCollections, isLoading, hasMore } = storeToRefs(store);
  const { load, $reset } = store;

  watch(
    storeCollections,
    () => {
      // trigger initial load or when views have reset

      if (store.collections.length === 0 && !store.isLoading && store.hasMore) {
        store.load(context, limit, MemberRole.Member);
      }
    },
    { immediate: true },
  );

  const collections = computed(() => {
    if (!filters) {
      return storeCollections.value;
    }
    return storeCollections.value.filter((collection) => useHasCollectionContents(ref(collection.id), filters).value);
  });

  const next = () => {
    if (store.isLoading && !store.hasMore) {
      return;
    }

    store.load(context, limit, MemberRole.Member);
  };

  return {
    collections,
    isLoading,
    hasMore,
    load,
    next,
    $reset,
  };
};

export default useMyMemberCollections;
